<div class="modal-content buyer-upload-modal">
    <div class="modal-header">
        <lsq-icon [type]="icons.CheckmarkCircleWithBubbles" [height]="130" [width]="160"></lsq-icon>
        <lsq-button
            *ngIf="modal.showCloseButton"
            appearance="transparent"
            class="close"
            ariaLabel="Close"
            (buttonClick)="close()"
        >
            <lsq-icon aria-hidden="true" [type]="icons.Close" [color]="colors.Black"> </lsq-icon>
        </lsq-button>
    </div>
    <div class="modal-body buyer-upload-modal-body">
        <h2>{{ title }}</h2>
        <div class="buyer-upload-success-subtitle">{{ subtitle }}</div>
        <lsq-button class="upload-successful-close-button" size="sm" i18n (buttonClick)="close()"
            >Close</lsq-button
        >
    </div>
</div>
